import React from "react";
import PropTypes from "prop-types";
import Head from "@/components/Head/Head";
import MainLayout from "@/components/MainLayout/MainLayout";
import LinkTo from "../Button/LinkTo";

const StaticPage = ({ breadcrumbsProps, isLoading, isLanding, StaticPageComponent, pageUrl }) => {
  return (
    <MainLayout breadcrumbs={breadcrumbsProps} isLoading={isLoading} isLanding={isLanding}>
      <Head pageTitle={breadcrumbsProps.title} url={pageUrl} />

      <StaticPageComponent Link={LinkTo} />
    </MainLayout>
  );
};

StaticPage.propTypes = {
  isLoading: PropTypes.bool,
  isLanding: PropTypes.bool,
  breadcrumbsProps: PropTypes.object,
  StaticPageComponent: PropTypes.oneOfType(PropTypes.func, PropTypes.node),
};

export default StaticPage;
